module.exports = __webpack_public_path__ + "img/AWS.13c4b711.svg";